import React, { useEffect, useState } from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import fr from 'locales/fr.yaml'
import styles from './vote.m.scss'

export const Vote = ({ itemId, locale, userId, articleId }) => {
  const [votes, setVotes] = useState({ upvotes: 0, downvotes: 0 })
  const [initialVotes, setInitialVotes] = useState({ upvotes: 0, downvotes: 0 })

  const sendVote = (
    markerId: string,
    userId: string,
    articleId: number,
    direction: string,
    initialVotes: { upvotes: number; downvotes: number }
  ) => {
    if (userId === null) {
      userId = window.localStorage.getItem(articleId + '-userId') || 'not-found'
      console.log('userId was undefined – found in localStorage:', userId)

      // TODO: make this an optional parameter and clean following lines
      if (userId === 'not-found') {
        console.warn('Vote impossible: l’utilisateur n’existe pas')
        return
      }
    }
    setVotes({
      upvotes: initialVotes.upvotes + (direction === 'up' ? 1 : 0),
      downvotes: initialVotes.downvotes + (direction === 'down' ? 1 : 0)
    })

    console.log(markerId, direction)

    firebase
      .database()
      .ref('votes/' + markerId)
      .child(userId)
      .set({
        vote: direction === 'up' ? 1 : -1, // nb: utiliser increment / decrement?
        ts: firebase.database.ServerValue.TIMESTAMP // time since the Unix epoch, in milliseconds
      })
    console.log('Sent to firebase as child')
  }

  function getVotes(marker: string) {
    let upvotes = 0
    let downvotes = 0

    firebase
      .database()
      .ref('votes/' + marker)
      .once('value')
      .then(snapshot => {
        snapshot.forEach(item => {
          if (item.val().vote === 1) {
            upvotes += 1
          } else if (item.val().vote === -1) {
            downvotes += 1
          }
        })
        // this variable keeps track of user clicks
        setVotes({ upvotes: upvotes, downvotes: downvotes })
        // this one only remembers the database values
        setInitialVotes({ upvotes: upvotes, downvotes: downvotes })
      })
  }
  useEffect(() => {
    getVotes(itemId)
  }, [itemId])

  return (
    <div className={styles.voteContainer}>
      <div className={styles.voteBtnContainer}>
        <button
          className={styles.voteBtn}
          onClick={() =>
            sendVote(itemId, userId, articleId, 'up', initialVotes)
          }
        >
          {/* <div className={styles.voteText}>Allez-y!</div> */}
          <i className='ui icon thumbs up' />
          <div className={styles.voteCounter}>{votes.upvotes}</div>
        </button>
      </div>
      <div className={styles.voteBtnContainer}>
        <button
          className={styles.voteBtn}
          onClick={() =>
            sendVote(itemId, userId, articleId, 'down', initialVotes)
          }
        >
          {/* <div className={styles.voteText}>À éviter</div> */}
          <i className='ui icon thumbs down' />
        </button>
        <div className={styles.voteCounter}>{votes.downvotes}</div>
      </div>
    </div>
  )
}
